import { Collapse } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import {
  getBookingOpenBoundary,
  getExtraBookingOpenBoundary,
  getBookingCloseBoundary,
} from "./BoatsBooking";

const { Panel } = Collapse;

// Placeholder values (replace these with actual dynamic data)
const PLACEHOLDERS = {
  selectedDate: "Monday, Nov 15th",
  openDate: "Friday, Nov 12th",
  openTime: "8:00 AM",
  closeTime: "5:00 PM",
  extraOpenTime: "10:00 AM",
};

const BookingRulesCollapse = ({
  selectedDate,
  advanceBookingDays,
  bookingOpenTime,
  bookingCloseTime,
  extraBookingOpenTime,
}) => {
  console.log({ selectedDate, advanceBookingDays, bookingOpenTime });

  if (!selectedDate || !advanceBookingDays || !bookingOpenTime) {
    return <></>;
  }

  const { dateStr: openDateStr, timeStr: openTimeStr } = getBookingOpenBoundary(
    selectedDate,
    advanceBookingDays,
    bookingOpenTime
  );

  const { dateStr: closeDateStr, timeStr: closeTimeStr } =
    getBookingCloseBoundary(selectedDate, advanceBookingDays, bookingCloseTime);

  const { dateStr: extraDateStr, timeStr: extraTimeStr } =
    getExtraBookingOpenBoundary(
      selectedDate,
      advanceBookingDays,
      extraBookingOpenTime
    );

  return (
    <Collapse
      defaultActiveKey={["1"]} // Keeps the panel open by default
      expandIconPosition="right"
      style={{ width: "100%" }}
    >
      <Panel
        header={
          <span style={{ fontWeight: "bold", fontSize: "1.1em" }}>
            <InfoCircleOutlined style={{ color: "#1890ff", marginRight: 8 }} />{" "}
            Booking Rules
          </span>
        }
        key="1"
      >
        <div style={{ padding: "0 8px" }}>
          <h3>Daily Bookings Limits (Total Bookings Per Boat Type)</h3>

          <ul style={{ listStyleType: "disc", paddingLeft: 20 }}>
            <li>
              Each school may book a maximum of{" "}
              <strong>two 1-hour slots per boat class per day. </strong>
            </li>
            <li>
              For example, School ABC may book the same quad for two consecutive
              hours or two different quads for one hour each either in the same
              hour or different hours.
            </li>

            <li hidden>
              <strong>Exempted Limit:</strong> If your school is exempt, the
              limit is <strong>3 total bookings per day</strong> for{" "}
              <strong>Single Scull and Double Scull</strong> only. For all other
              boat types, the standard 2-bookings limit applies.
            </li>
          </ul>
          <h3 style={{ marginTop: "16px" }}>
            Booking Window & Time Restrictions
          </h3>
          <ul style={{ listStyleType: "disc", paddingLeft: 20 }}>
            <li>
              All boat bookings must be made one day in advance. Same-day
              bookings will not be permitted.
            </li>
            <li>
              Bookings for the selected date will open on{" "}
              <strong>{openDateStr}</strong> at
              <strong> {openTimeStr} </strong>
              and close at <strong>{closeTimeStr}</strong>.
            </li>
            <li hidden>
              <strong>3rd Booking Time:</strong> The third booking for an
              exempted school and boat type can only be made starting on
              <strong> {openDateStr}</strong> at <strong></strong>{" "}
              <strong>{extraTimeStr}</strong>.
            </li>
          </ul>
        </div>
      </Panel>
    </Collapse>
  );
};

export default BookingRulesCollapse;
